<div class="availability">
  @if (availability()) {
    <div>
      Available
      {{ availability().startTime | timeParse | dateFormat: 'HH:mm' }} -
      {{ availability().endTime | timeParse | dateFormat: 'HH:mm' }}
    </div>
  } @if (!availability()) {
  <div>
    Unavailable
  </div>
}
</div>